import { useCurrentStateAndParams } from "@uirouter/react";
import styled from "styled-components";

import { updateFilterConsistencyCountry } from "app/routes/handlers/filter-consistency/filterConsistencyUtils";
import * as utils from "app/components/filters-bar/utils";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import type { ICountryObject } from "app/services/CountryService";
import CountryService from "app/services/CountryService";

import { MonitorKeywordsResponsiveFilters } from "./MonitorKeywordsResponsiveFilters";

const MonitorKeywordsResponsiveFiltersWrapper = styled.div.attrs({
    className: "react-filters-container",
})`
    flex: 0.8;
    overflow: hidden;
`;

export const MonitorKeywordsFiltersInner = () => {
    const { country: currentCountry } = useCurrentStateAndParams().params;
    const countryObject: ICountryObject = CountryService.getCountryById(currentCountry);

    const getAvailableCountries = () => {
        return utils.getCountries();
    };

    const onChangeCountry = (country: number | ICountryObject) => {
        let updatedCountryObject: ICountryObject;
        if (typeof country === "number") {
            updatedCountryObject = CountryService.getCountryById(country);
        } else {
            updatedCountryObject = country;
        }
        if (currentCountry === updatedCountryObject?.id) {
            return;
        }
        updateFilterConsistencyCountry(updatedCountryObject?.id);

        void proNavigator.updateParams({ country: updatedCountryObject?.id, isCountryChanged: null });
    };

    return (
        <MonitorKeywordsResponsiveFiltersWrapper>
            <MonitorKeywordsResponsiveFilters
                selectedCountryId={countryObject.id}
                selectedCountryText={countryObject.text}
                availableCountries={getAvailableCountries()}
                onCountryChange={onChangeCountry}
            />
        </MonitorKeywordsResponsiveFiltersWrapper>
    );
};
